export default {
  authenticationCheck: '/authentication_check',
  externalSessionsAuthenticate: '/external-sessions/authenticate?token=:token',
  login: '/authentication',
  loginExternal: '/authentication_external',
  switchSchool: '/switch-school?subinstall=:subinstall',
  languages: '/languages',
  autosaveServiceAutosave: '/autosave-service/auto-save',
  externalAnalyticsDashboard: '/external_analytics_dashboard',
  // <-------------------- Teacher Dashboard -------------------->
  teacherRecentScopes: '/teacher_widgets/recent_scopes',
  teacherWidgetsNotes: '/teacher_widgets/recent_notes',
  teacherWidgetsAnnouncements: '/teacher_widgets/announcements',
  teacherWidgetsUpcomingLessons: '/teacher_widgets/upcoming_lessons',
  teacherWidgetBookmarkFolders: '/teacher_widgets/bookmark_folders',
  teacherWidgetsLatestActivity: '/teacher_widgets/latest_activity',
  teacherWidgetsSections: '/teacher_widgets/classes',
  teacherWidgetsDashboardBanner: '/teacher_widgets/dashboard_banner',
  teacherWidgetsDistrictAssignments: '/teacher_widgets/district_assignments',
  teacherWidgetsGoogleClasses: '/teacher_widgets/google_classes',
  teacherCampaignStaffAssignment: '/campaign_staff_assignment',
  teacherSaveCampaignStaffAssignment: '/campaign_staff_assignment/save',
  teacherSubmitStaffAssignment: '/campaign_staff_assignment/submit',
  // <-------------------- Student Dashboard -------------------->
  studentWidgetsDashboardBanner: '/student_widgets/dashboard_banner',
  notStartedAssignments: '/student_widgets/assignments_not_started',
  actualDistrictAssignments: '/student_widgets/district_assignments',
  assignmentLabels: '/student_widgets/assignment_labels',
  startedAssignments: '/student_widgets/assignments_in_progress',
  notificationMessage: '/student_widgets/notification_message',
  assignmentsCount: '/student_widgets/assignments_total_count',
  // <-------------------- Glossary -------------------->
  glossaryVideos: '/glossary_videos',
  glossaryLetters: '/glossary_videos/letters_by_language',
  // <-------------------- Curriculum Areas -------------------->
  curriculumAreas: '/curriculum_areas',
  // <-------------------- Activity -------------------->
  activities: '/notifications',
  unreadActivitiesCount: '/notifications/unread_count',
  markAsRead: '/notifications/mark_as_read',
  // <-------------------- Standards -------------------->
  standards: '/standards',
  standard: '/standards/:id',
  standardElements: '/standards/:id/content_elements',
  standardElementParts: '/standards/:id/content_element_parts',
  filterStandards: '/standards/:id/descendants',
  // <-------------- Student Assignments -------------->
  studentAssignments: '/student_assignments',
  studentAssignment: '/student_assignments/:id',
  studentAssignmentAssignedElementParts:
    '/student_assignments/:id/assigned_element_parts',
  autoSaveStudentAssignment: '/student_assignments/:id/autosave',
  resetStudentAssignment: '/student_assignments/:id/reset',
  rejectStudentAssignment: '/student_assignments/:id/reject',
  reassignGrader: '/student_assignments/:id/reassign_grader',
  switchAssignmentLanguage: '/student_assignments/:id/switch_language',
  // <-------------------- Classes -------------------->
  teachers: '/teachers',
  teacherTokens: '/teachers/tokens',

  learningResources: '/learning_resources',
  learningResource: '/learning_resources/:id',
  learningResourceElementType: '/learning_resources/:id/show_element_type',
  displayElement:
    '/learning_resources/:id/display_element?tsid=:teacherSectionId',
  teacherSections: '/teacher_sections',
  teacherSectionsDistrictAssignments: '/teacher_sections/district_assignments',
  teacherSection: '/teacher_sections/:id',
  createTeacherSection: '/teacher_sections',
  updateTeacherSection: '/teacher_sections/:id',
  gradeLevels: '/grade_levels',
  teacherSectionsLearningResources:
    '/teacher_sections/:teacherSectionId/learning_resources',
  learningResourcesAvailable: '/teacher_sections/learning_resources_available',
  teacherSectionArchive: '/teacher_sections/:id/archive',
  teacherSectionRestore: '/teacher_sections/:id/restore',
  teacherSectionAddStudent: '/teacher_sections/:teacherSectionId/add_student',
  teacherSectionRemoveStudent:
    '/teacher_sections/:teacherSectionId/remove_student',
  // <-------------------- Streaming -------------------->
  assetsByTopic: '/media_assets/count_by_topic',
  activityTypes: '/media_assets/activity_types',
  countByEntity: '/media_assets/count_by_entity',
  categoryTypes: '/media_assets/category_types',
  recentlyViewedResources: '/media_assets/recently_viewed',
  newsEntries: '/media_assets/news_entries',
  mediaAssets: '/media_assets',
  mediaAsset: '/media_assets/:id',
  // <-------------------- Grades -------------------->
  grades: '/grades',
  // <-------------------- Topics -------------------->
  topics: '/topics',
  // <-------------------- Assignments -------------------->
  teacherSectionAssignments: '/teacher_section_assignments',
  teacherSectionAssignment: '/teacher_section_assignments/:id',
  allTeacherSectionAssignments: '/teacher_section_assignments/all_active',
  teacherSectionAssignmentsArchive: '/teacher_section_assignments/:id/archive',
  teacherSectionAssignmentsReset: '/teacher_section_assignments/:id/reset',
  teacherSectionAssignmentsToggleFeedback:
    '/teacher_section_assignments/:id/toggle_feedback',
  teacherSectionAssignmentsRejectAllStudentAssignments:
    '/teacher_section_assignments/:id/reject_all_student_assignments',
  teacherSectionAssignmentsRejectForStudent:
    '/teacher_section_assignments/:id/reject_for_student',
  teacherSectionAssignmentsArchiveGroup:
    'teacher_section_assignments/archive_group',
  teacherSectionAssignmentsRestore: '/teacher_section_assignments/:id/restore',
  teacherSectionAssignmentsUpdatePause:
    '/teacher_section_assignments/:id/update_pause',
  teacherSectionAssignmentDownloadGradeCsv:
    '/teacher_section_assignments/:id/download_grades.csv',
  teacherSectionAssignmentDownloadGradeXlsx:
    '/teacher_section_assignments/:id/download_grades.xlsx',
  teacherSectionAssignmentAnalytics:
    '/teacher_section_assignments/:id/analytics_data',
  downloadAnalytics: '/teacher_section_assignments/:id/download_analytics',
  archiveAssignment: '/teacher_section_assignments/:id/archive',
  restoreAssignment: '/teacher_section_assignments/:id/restore',
  gradeQuestions: '/teacher_section_assignment_results/:id/grade_questions',
  updateQuestions: '/teacher_section_assignment_results/:id',
  setAllQuestionsGrade:
    '/teacher_section_assignment_results/:id/set_all_questions_grade',
  studentResponses: '/student_responses/:id',
  // <-------------------- Scopes -------------------->
  scopes: '/scopes',
  scope: '/scopes/:id',
  scopeFilters: (id?: string) =>
    id ? `/scope_filters/${id}` : '/scope_filters',
  scopeSelectors: 'scopes/filter_selectors',
  bookmarkFolders: '/teacher_bookmark_folders',
  sortedBookmarkFolders: '/teacher_bookmark_folders/alpha_sort_all',
  bookmarkFolder: '/teacher_bookmark_folders/:id',
  removeSelectedBookmarks: '/teacher_bookmark_folders/remove_selected',
  scopeBookmark: '/teacher_scope_bookmarks/:id',
  sortScopeBookmarks: '/teacher_scope_bookmarks/sort',
  sortElementBookmarks: '/teacher_element_bookmarks/sort',
  elementBookmark: '/teacher_element_bookmarks/:id',
  updateScopeFolders: '/teacher_scope_bookmarks/update_folders',
  updateElementFolders: '/teacher_element_bookmarks/update_folders',
  teacherSectionAssignmentsResults: '/teacher_section_assignment_results/:id',
  reassignGraderForTsa:
    '/teacher_section_assignment_results/:id/reassign_grader',
  standardsForScope: '/scopes/:id/standards_for_dropdown',
  // <-------------------- Teachers -------------------->
  teacher: '/teachers/:id',
  // <-------------------- Students -------------------->
  students: '/students',
  student: '/students/:id',
  studentAccount: '/student_account/:id',
  studentsGradeLevels: '/students/grade_levels',
  studentShowForTeacherSection: '/students/:id/show_for_teacher_section',
  studentUpdateStatus: '/students/:id/update_status',
  // <-------------------- Elements -------------------->
  element: '/elements/:id',
  elements: '/elements',
  elementAttachedFiles: '/elements/:id/attached_files',
  combinedElementParts: '/elements/:id/combined_element_parts',
  standardsForElement: '/elements/:id/standards_for_dropdown',
  // <-------------------- Sections -------------------->
  sections: '/sections',
  // <-------------------- Stemcoach -------------------->
  stemcoachDomains: '/stemcoach_domains',
  stemcoachDomain: '/stemcoach_domains/:id',
  stemcoachActions: '/stemcoach_actions',
  stemcoachAction: '/stemcoach_actions/:id',
  // <-------------------- Assessments -------------------->
  assessments: '/teacher_assessments',
  assessment: '/teacher_assessments/:id',
  assessmentAnswerKeys: '/teacher_assessments/:id/answer_key',
  assessmentCopy: '/teacher_assessments/:id/copy',
  assessmentAcceptShare: '/teacher_assessments/:id/accept_share',
  assessmentArchive: '/teacher_assessments/:id/archive',
  assessmentUnarchive: '/teacher_assessments/:id/unarchive',
  assessmentDownload: '/teacher_assessments/:id/download',
  assessmentShare: '/teacher_assessment_shares',
  assessmentEdit: '/teacher_assessments/:id/edit',
  assessmentTotalCount: '/teacher_assessments/total_count',
  assessmentsPending: '/teacher_assessments/pending',
  availableQuestions: '/teacher_assessments/available_questions',
  packageAssessments: '/package_assessments',
  packageAssessment: '/package_assessments/:id',
  packageAssessmentsGradeLevels: '/package_assessments/grade_levels',
  togglePackageAssessment: '/package_assessments/:id/toggle_favorite',
  // <------------- Assessment Bank Question -------------->
  ABQTags: '/assessment_bank_question_tags',
  ABQEditionsForLessons:
    '/assessment_bank_question_lessons/editions_for_lessons',
  ABQEditionsForStandards:
    '/assessment_bank_question_standards/editions_for_standards',
  ABQLessons: '/assessment_bank_question_lessons',
  ABQStandards: '/assessment_bank_question_standards',
  ABQTopics: '/assessment_bank_question_topics',
  ABQGradeLevels: '/assessment_bank_questions/grade_levels',
  // <-------------------- Lesson Planner -------------------->
  plannedElements: '/planned_elements',
  plannedElement: '/planned_elements/:id',
  plannedElementsAudienceOptions: '/planned_elements/audience_options',
  plannedElementsRecordTypes: '/planned_elements/record_types',
  lessonPlans: '/lesson_plans',
  lessonPlansDownload: '/lesson_plans/download',
  lessonPlansClearAll: '/lesson_plans/clear_all',
  lessonPlan: '/lesson_plans/:id',
  lessonPlanImport: '/lesson_plans/:id/import',
  // <-------------------- Highlights -------------------->
  highlights: '/highlights',
  teacherHighlights: '/highlights/teacher_highlights',
  sectionComments: '/comments/teacher_comments',
  studentHighlights: '/student_assignment_highlights/student_highlights',
  studentComments: '/student_assignment_comments/student_comments',
  highlight: '/highlights/:id',
  studentAssignmentHighlights: '/student_assignment_highlights',
  studentAssignmentHighlight: '/student_assignment_highlights/:id',
  // <-------------------- Comments -------------------->
  comments: '/comments',
  comment: '/comments/:id',
  studentAssignmentComments: '/student_assignment_comments',
  studentAssignmentComment: '/student_assignment_comments/:id',
  // <-------------------- Accessibility Settings-------------------->
  accessibility: '/update_accessibility_settings',
  // <-------------------- Feedback -------------------->
  feedbackReasonList: '/feedback/reason_list',
  feedbackSuggestionList: '/feedback/suggestion_list',
  feedbackCreate: '/feedback',
  feedbackFileUpload: '/feedback-upload',
  // <-------------------- District Assignment -------------------->
  districtAssignments: '/district_assignments',
  districtAssignment: '/district_assignments/:id',
  districtAssignmentToggleFeedback: '/district_assignments/:id/toggle_feedback',
  districtStudentAssignments: '/district_student_assignments',
  districtStudentAssignment: '/district_student_assignments/:id',
  districtStudentAssignmentSave: '/district_student_assignments/:id/save',
  districtAssignmentAnalytics: '/district_assignments/:id/analytics_data',
  districtAssignmentStartSection: '/district_assignments/:id/start',
  downloadDistrictAssignmentAnalytics:
    '/district_assignments/:id/download_analytics',
  districtAssignmentSnapshot: '/district_assignments/:id/snapshot',
  districtAssignmentReset: '/district_student_assignments/:id/reset',
  districtAssignmentReturn: '/district_student_assignments/:id/reject', // ?comment=string
  // <-------------------- Google Class Rooms -------------------->
  googleClassRoomsCoursesFromGoogle: '/google_class_rooms/courses_from_google',
  googleClassRoomsStemCourses: '/google_class_rooms/stem_courses',
  googleClassRoomsImportSections: '/google_class_rooms/import_sections',
  googleClassRoomsSynchronize: '/google_class_rooms/synchronize',

  // <-------------------- LTI -------------------->
  ltiSelectLink:
    '/lti_select_link/:id' /* ?selection_type=element|package_assessment(352) */,
  ltiRemoveLink:
    '/lti_remove_link/:id' /* ?selection_type=element|package_assessment(352) */,

  ltiSubmitLink: '/lti_submit_content_item_links',
  ltiTurnIn: '/ims/lti/v1/student_assignments/:id',
  ltiSave: '/ims/lti/v1/student_assignments/:id/autosave',
  ltiTeacherSectionAssignments: '/ims/lti/v1/teacher_section_assignments/:id',
  ltiStudentAssignment: '/ims/lti/v1/student_assignments/:id',
  ltiStudentAssignmentAssignedElementParts:
    '/ims/lti/v1/student_assignments/:id/assigned_element_parts',
  // <-------------------- Other Scores -------------------->
  otherScores: '/student_other_scores',
  generateOtherScores: '/student_other_scores/generate_other_scores',
  showOtherScores: '/student_other_scores/:id',
  checkCompletedReport: '/student_other_scores/check_completed_report',
  downloadOtherScores: '/student_other_scores/:otherScoresId/download',
};
